import * as React from "react";
import { PureComponent } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  withWidth,
  Tooltip
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { CustomerState } from "../../types/authentication";
import { TitleBar } from "../../types/titleBar";
import { WithWidth, isWidthDown } from "@material-ui/core/withWidth/withWidth";
import { cssVars, layoutBreakpoint } from "src/globalCssVars";
import { RGB } from "src/external/utilities/colorUtil";
import { CancelOutlined } from "@material-ui/icons";

interface ApptsAppBarProps extends WithWidth, WithStyles<typeof styles> {
  title: TitleBar;
  customerState: CustomerState;
  onIconClick: () => void;
  primaryRgbColor: RGB;
  showCancelButton: boolean;
  tooltipText: string;
  onCancelClick: () => void;
}

interface ApptsAppBarState {}

class ApptsAppBar extends PureComponent<ApptsAppBarProps, ApptsAppBarState> {
  constructor(props: ApptsAppBarProps) {
    super(props);
  }

  render() {
    const {
      title,
      onIconClick,
      classes,
      width,
      primaryRgbColor,
      showCancelButton,
      onCancelClick,
      tooltipText
    } = this.props;
    const rgba = `rgba(${primaryRgbColor.r}, ${primaryRgbColor.g}, ${primaryRgbColor.b}, 0.8)`;
    const isMobile = isWidthDown(layoutBreakpoint, width);
    return (
      <AppBar
        className={classes.root}
        style={{
          backgroundImage: `linear-gradient(${rgba}, ${rgba}), url("./img/banner.jpg")`
        }}
        position="fixed"
      >
        <Toolbar classes={{ root: isMobile ? classes.mobileToolbar : classes.webToolbar }}>
          {
            <IconButton classes={{ root: classes.iconButton }} onClick={onIconClick}>
              <MenuIcon />
            </IconButton>
          }
          {showCancelButton && (
            <Tooltip
              title={<Typography className={classes.tooltipText}>{tooltipText}</Typography>}
              placement={"bottom"}
              disableTouchListener={false}
              disableHoverListener={false}
            >
              <CancelOutlined fontSize={"large"} classes={{ root: classes.cancelButton }} onClick={onCancelClick} />
            </Tooltip>
          )}
          <div>
            <Typography
              classes={{
                root: isMobile ? classes.mobileTypography : classes.webTitleTypography
              }}
              variant="h6"
              noWrap={true}
            >
              {title.title}
            </Typography>
            {!isMobile && (
              <Typography classes={{ root: classes.webDescriptionTypography }}>{title.description}</Typography>
            )}
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

const styles = (theme: Theme) => {
  const headerOffset = // Left-align the title text with the content.
    cssVars.webStepperMinWidth + // Stepper width
    2 * theme.spacing.unit + // plus the left and right margin on the stepper
    theme.spacing.unit - // plus the left padding of the content
    cssVars.toolbarPaddingLeft - // minus the tool bar left padding
    cssVars.toolbarMenuButtonWidth; // minus the toolbar menu button width (plus padding?)

  return createStyles({
    iconButton: {
      color: "white"
    },
    mobileToolbar: {},
    mobileTypography: {
      color: "white"
    },
    webDescriptionTypography: {
      color: "white",
      marginLeft: headerOffset + "rem",
      fontSize: "1em"
    },
    webTitleTypography: {
      color: "white",
      marginLeft: headerOffset + "rem",
      fontSize: "2em"
    },
    root: {
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center"
    },
    webToolbar: {},
    cancelButton: {
      position: "absolute",
      left: `calc(100vw - 4rem)`,
      cursor: "pointer"
    },
    tooltipText: {
      color: "white"
    }
  });
};

export default withStyles(styles)(withWidth()(ApptsAppBar));
